module.exports = __webpack_public_path__ + "715eb398d6f9dec1e6ea0334e7d47152.jpg";